var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar-button',{attrs:{"icon":"mdi-file-plus-outline","tooltip":_vm.tooltip ? _vm.tooltip : 'Create new content'},on:{"click":_vm.openCreateContentModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }